
export function buildMessage(message, type) {
    return {
        message: message,
        type: type
    }
}